//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { GridController, GridOptions, GridTypes } from '../../common/grid/grid.controller'
import { IIMRParameters, IMRParametersOptions, IMRParametersInitializedArgs } from '../../common/parameters'
import { IBasicParametersExtension, BasicParametersExtension } from '../../common/parameters/extensions'
import { IIMRErrorsSummary, SummaryOptions, ErrorRowItem, IMRErrorsSummaryOptions } from './'

import { TypeHelper } from '../../../helpers'
import { ErrorsSummaryService } from './services'

export class IMRErrorsSummaryController implements ng.IComponentController, IIMRErrorsSummary {

    // #region Consts

    private static get ERRORS_SUMMARY_GRID_NAME(): string { return 'ErrorsSummaryGrid' }

    // #endregion


    // #region Members

    private options: IMRErrorsSummaryOptions
    private errorsSummaryParameters: IIMRParameters<IBasicParametersExtension>
    private errorsSummaryParametersOptions: IMRParametersOptions<IBasicParametersExtension>
    private summaryOptions: SummaryOptions

    public title: string

    private errorsSummaryGrid: GridController<ErrorRowItem>
    public errorsSummaryGridOptions: GridOptions = null

    // #endregion


    // #region Ctor

    constructor(
        private errorsSummaryService: ErrorsSummaryService
    ) { }

    // #endregion

    // #region IIMRErrorsSummary Implementation

    public setSummaryOptions(summaryOptions: SummaryOptions): void {
        this.summaryOptions = summaryOptions
        this.update()
    }

    // #endregion


    // #region IComponentController Implementation 

    public $onChanges(changes: { [index: string]: ng.IChangesObject<any> }): void {
        if (TypeHelper.isOptionsDefined(changes)) {
            this.initialize()
        }
    }

    // #endregion


    // #region Component

    private initialize(): void {

        if (this.options != null) {

            $.when(
                this.initializeErrorsSummaryParameters(),
                this.initializeErrorsSummaryGrid()
            ).then(() => {
                this.onInitialized()
            })

        }
    }

    // #endregion


    // #region Events

    private onInitialized(): void {
        if (this.options != null && _.isFunction(this.options.onInitialized)) {
            this.options.onInitialized(this)
        }
    }

    // #endregion

    private update(): void {
        this.updateErrorsSummaryParameters()
        this.updateErrorsSummaryGrid()
    }

    private initializeErrorsSummaryParameters(): JQueryPromise<void> {
        this.errorsSummaryParametersOptions = {
            extension: new BasicParametersExtension({
                parameters: this.errorsSummaryService.getErrorsSummaryParameters(null)
            }),
            showEmpty: true,
            onInitialized: (e: IMRParametersInitializedArgs<IBasicParametersExtension>) => {
                return this.errorsSummaryParameters = e.component
            }
        }

        return TypeHelper.onInitializedAll(this.errorsSummaryParametersOptions)
    }

    private initializeErrorsSummaryGrid(): JQueryPromise<any> {
        this.errorsSummaryGridOptions = {
            name: IMRErrorsSummaryController.ERRORS_SUMMARY_GRID_NAME,
            type: GridTypes.PAGINATED_SMALL,
            buttonsOptions: {
                enabled: true,
                isRefreshButonHidden: true
            },
            addCustomFilters: true,
            columnsDictionary: this.errorsSummaryService.getErrorsSummaryGridColumns(),
            onInitialized: (e: any, gridController: GridController<ErrorRowItem>) => this.errorsSummaryGrid = gridController,
            onSelectionChanged: (e: any): void => {
                if (this.options.onSelectErrorRows != null) {
                    this.options.onSelectErrorRows(this.errorsSummaryService.createSelectedErrorsArray(e.selectedRowsData))
                }
            }
        }

        return TypeHelper.onInitializedAll(this.errorsSummaryGridOptions)
    }

    private updateErrorsSummaryParameters(): void {
        if (this.errorsSummaryParameters != null) {
            if (this.summaryOptions != null) {
                this.errorsSummaryParameters.extension.setParameters(this.errorsSummaryService.getErrorsSummaryParameters(this.summaryOptions))
                this.title = this.summaryOptions.title
            }
            else {
                this.errorsSummaryParameters.extension.setParameters(this.errorsSummaryService.getErrorsSummaryParameters(null))
            }

            this.errorsSummaryParameters.refresh()
        }
    }

    private updateErrorsSummaryGrid(): void {
        if (this.errorsSummaryGrid != null) {
            this.errorsSummaryGrid.dxGrid.option('dataSource', this.errorsSummaryService.createErrorsDataset(this.summaryOptions.summaryResult, this.summaryOptions.errorMarker))
        }
    }

}